export const testId = (value: string) => {
  if (import.meta.env.DEV) {
    return value;
  }

  return undefined;
};
